import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { InteractiveHoverButton } from '../ui/InteractiveHoverButton';
import { HoverBorderGradient } from '../ui/HoverBorderGradient';
import { MagneticButton } from '../ui/MagneticButton';

const ProductCard = ({ product, isFirst, isSecond, isThird }) => {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);

  return (
    <button
      onClick={() => navigate(`/shop/product/${product.id}`)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'block',
        width: '100%',
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        textAlign: 'left',
      }}
    >
      {/* Image */}
      <div
        style={{
          position: 'relative',
          width: '100%',
          aspectRatio: '4/3',
          overflow: 'hidden',
          borderRadius: 2,
          background: '#111',
        }}
      >
        <img
          src={product.image}
          alt={product.title}
          loading="lazy"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            transition: 'transform 0.5s ease',
            transform: hovered ? 'scale(1.05)' : 'scale(1)',
            display: 'block',
          }}
        />
        {/* Hover overlay */}
        {(isFirst || isSecond || isThird) && (
          <div
            style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              padding: '0 16px 16px',
              opacity: hovered ? 1 : 0,
              transition: 'opacity 0.3s ease',
              display: 'flex',
              justifyContent: 'center',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {isFirst && (
              <InteractiveHoverButton
                text="ADD TO CART"
                className="w-full rounded-full text-xs tracking-widest uppercase"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              />
            )}
            {isSecond && (
              <HoverBorderGradient
                containerClassName="w-full"
                className="w-full text-center text-xs tracking-widest uppercase"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                ADD TO CART
              </HoverBorderGradient>
            )}
            {isThird && (
              <div className="w-4/5">
                <MagneticButton distance={0.4} className="w-full">
                  <button
                    style={{ fontFamily: 'Montserrat, sans-serif' }}
                    className="w-full bg-black/60 backdrop-blur-sm border border-white/60 text-white text-xs tracking-widest uppercase px-4 py-2 rounded-full transition-colors duration-300 hover:bg-[#36454F] font-light"
                  >
                    + ADD TO CART
                  </button>
                </MagneticButton>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Info */}
      <div style={{ padding: '14px 0' }}>
        <h3
          style={{
            fontFamily: 'Montserrat, sans-serif',
            fontWeight: 500,
            fontSize: 14,
            color: '#ffffff',
            letterSpacing: '0.1em',
            margin: 0,
            textTransform: 'uppercase',
          }}
        >
          {product.title}
        </h3>
        <p
          style={{
            fontFamily: 'Montserrat, sans-serif',
            fontWeight: 300,
            fontSize: 14,
            color: 'rgba(255,255,255,0.6)',
            margin: '6px 0 0',
          }}
        >
          ${product.price.toFixed(2)}
        </p>
      </div>
    </button>
  );
};

export default ProductCard;
